module.exports = __webpack_public_path__ + "static/mobile-app-daily-top-app-development-company-award-e0220e5a4c0d78e7abf3a517089f3b34.png";